import { Footer, Header, Page } from './components'

import './App.scss';

function App()
{
    return (
        <div id="App">
            <Header />
            <Page />
            <Footer />
        </div>
    );
}

export default App;
